/**
 * Application Entry Point
 *
 * This is the main entry point for the React application.
 * It sets up:
 * - React 18's createRoot API for concurrent features
 * - AuthProvider for authentication context
 * - Global CSS styles
 *
 * Note: Routing is handled inside App.jsx using createBrowserRouter
 * to support data router features like useBlocker.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import './index.css';

// Find the root element in index.html
const rootElement = document.getElementById('root');

// Create a React root and render the application
// StrictMode helps identify potential problems in development
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    {/* AuthProvider makes authentication state available throughout the app */}
    <AuthProvider>
      {/* App contains RouterProvider with createBrowserRouter for data router features */}
      <App />
    </AuthProvider>
  </React.StrictMode>
);
